import { Icon, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Pressable, Skeleton } from 'native-base';
import React from 'react';

export namespace RateManagementSubHeaderSectionTypes {
  export interface Props {
    isMobile?: boolean;
    loading?: boolean;
    onRefresh?: () => void;
  }
}

export const SubHeader: React.FC<RateManagementSubHeaderSectionTypes.Props> = ({
  isMobile,
  loading,
  onRefresh,
}) => {
  return (
    <Box
      borderTopRadius={isMobile ? 0 : Spacing['inline.nano']}
      mt={isMobile ? 0 : Spacing['inset.sm']}
      bg={Utils.Responsive.All({
        phone: 'transparent',
        tablet: Color['neutral.white'],
        desktop: Color['neutral.white'],
      })}
      px={Utils.Responsive.All({
        phone: '0',
        tablet: Spacing['inline.xxxs'],
        desktop: Spacing['inline.xxxs'],
      })}
      py={!isMobile ? '20.5px' : 0}
      borderBottomWidth={Utils.Responsive.All({
        phone: '0',
        tablet: 0.5,
        desktop: 0.5,
      })}
      borderBottomColor={Utils.Responsive.All({
        phone: 'transparent',
        tablet: Color['neutral.lightest'],
        desktop: Color['neutral.lightest'],
      })}>
      <HStack
        paddingBottom={isMobile ? Spacing['inline.xxxs'] : 0}
        alignItems="center"
        justifyContent="space-between"
        space={Spacing['stack.xxxs']}>
        <Text
          color="brand.primary.principal"
          fontSize={Utils.Responsive.All({
            phone: Typography['fontsize.md'],
            tablet: Typography['fontsize.lg'],
            desktop: Typography['fontsize.lg'],
          })}
          lineHeight="distant"
          variant="semibold">
          Lista de clientes
        </Text>
        {loading ? (
          <Skeleton height="14px" width={'20%'} borderRadius={BoxRadius.sm} />
        ) : (
          <Pressable testID="refresh-button" onPress={onRefresh}>
            <HStack space={1} alignItems="center" justifyContent="center">
              <Text
                py={1.5}
                alignSelf="center"
                textAlign="center"
                color="brand.tertiary.principal"
                variant="semibold"
                fontSize={Typography['fontsize.xs']}>
                ATUALIZAR
              </Text>
              <Icon
                testId="button-icon-refresh"
                name="Refresh"
                size="xxs"
                color={Color['brand.tertiary.principal']}
              />
            </HStack>
          </Pressable>
        )}
      </HStack>
    </Box>
  );
};
